/**
 * CHECKBOX CELL
 * Cellule avec checkbox pour sélection multiple
 */

import type { Row } from '@tanstack/react-table';
import { Checkbox } from '../../ui/checkbox';

interface CheckboxCellProps<TData> {
  row: Row<TData>;
}

export function CheckboxCell<TData>({ row }: CheckboxCellProps<TData>) {
  const handleChange = (newValue: boolean) => {
    // On passe directement la nouvelle valeur au lieu de toggle
    row.toggleSelected(newValue);
  };

  return (
    <div className="flex items-start gap-2 px-3 py-1.5">
      <Checkbox checked={row.getIsSelected()} onChange={handleChange} />
    </div>
  );
}
